// Phase 1 strings: tasks, cases, rounds, runner, CLI tokens.
const tasksEn = {
  status: {
    pass: "Pass",
    fail: "Fail",
    blocked: "Blocked",
    skipped: "Skipped",
    untested: "Untested",
    stale: "Stale",
    staleHint: "The case changed after this result was recorded.",
    summary: "{{pass}} passed, {{fail}} failed, {{blocked}} blocked, {{skipped}} skipped, {{untested}} untested",
    nPass: "{{count}} passed",
    nFail: "{{count}} failed",
    nBlocked: "{{count}} blocked",
    nSkipped: "{{count}} skipped",
    nStale: "{{count}} stale",
    nUntested: "{{count}} untested",
  },
  taskState: {
    draft: "Draft",
    ready_for_test: "Ready for test",
    in_testing: "In testing",
    changes_requested: "Changes requested",
    ready_for_retest: "Ready for retest",
    passed: "Passed",
    closed: "Closed",
  },
  priority: {
    critical: "critical",
    high: "high",
    medium: "medium",
    low: "low",
  },
  source: {
    claude: "claude",
    manual: "manual",
  },
  replyKind: {
    fixed: "Fixed",
    wont_fix: "Won't fix",
    not_a_bug: "Not a bug",
    comment: "Comment",
  },
  inbox: {
    title: "Inbox",
    intro: "Tasks waiting for you across all your projects.",
    toTest: "To test",
    toFix: "To fix",
    toTestEmpty: "Nothing is waiting for testing.",
    toFixEmpty: "No changes are requested from you.",
  },
  tasks: {
    filterPeople: "People",
    myTurn: "My turn",
    mine: "Mine",
    inStateSince: "{{state}} since {{time}}",
    title: "Tasks",
    newTask: "New task",
    search: "Search by key or title",
    filterState: "Filter by state",
    openOnly: "Open",
    empty: "No tasks yet",
    emptyBody: "Create a task here, or let Claude create it from the CLI.",
    noMatch: "No tasks match these filters.",
    taskTitle: "Title",
    description: "Description",
    developer: "Developer",
    tester: "Tester",
    unassigned: "Unassigned",
    created: "Task {{key}} created",
    keyInvalid: "Use a task key: letters, a dash and a number (PAY-482).",
    caseCount: "Cases: {{count}}",
    notTested: "Not tested yet",
    roundN: "R{{n}}",
    updated: "Updated {{time}}",
    task: "Task",
    state: "State",
    progress: "Latest round",
    people: "People",
  },
  task: {
    turnYours: "Your turn",
    turn: {
      developer: "Waiting for developer",
      tester: "Waiting for tester",
      manager: "Waiting for a manager to close it",
    },
    roundN: "Round {{n}}",
    markReady: "Ready for testing",
    requestRetest: "Request retest",
    startRound: "Start round",
    continueRound: "Continue round {{n}}",
    viewRound: "View round {{n}}",
    finishRound: "Finish round",
    close: "Close task",
    reopen: "Reopen",
    addCase: "Add case",
    progressActive: "Round {{n}} · {{done}} of {{total}} recorded",
    progressLatest: "Round {{n}} finished · {{done}} of {{total}} recorded",
    startedBy: "started {{time}} by {{name}}",
    finishedAt: "finished {{time}}",
    noCases: "No test cases yet",
    noCasesBody: "Add cases here, or push them from Claude with the CLI:",
    liveUpdate: "{{name}} updated {{what}}",
    liveUpdateGeneric: "{{name}} made changes to this task",
    someone: "Someone",
    dismiss: "Dismiss",
    tabCases: "Test cases",
    tabRounds: "Rounds",
    tabActivity: "Activity",
    tabCode: "Code",
    retestTitle: "Request a retest",
    retestHint: "The tester sees this note when they start the next round.",
    retestNote: "What changed",
    retestPlaceholder: "e.g. Fixed TC-3 and TC-4, TC-8 is not a bug (see reply)",
    retested: "Retest requested",
    markedReady: "Marked ready for testing",
    closedToast: "Task closed",
    reopenedToast: "Task reopened",
    closeTitle: "Close {{key}}?",
    closeBody: "Closed tasks are hidden from lists and inboxes. You can reopen it later; nothing is deleted.",
    assigneeSaved: "Assignee updated",
    editTask: "Edit task",
    taskSaved: "Task saved",
    noDescription: "No description.",
    actions: "Task actions",
  },
  round: {
    startTitle: "Start round {{n}}",
    scope: "Cases to test",
    scopeAll: "All cases",
    scopeRetest: "Retest: failed, changed and new",
    selected: "{{count}} of {{total}} selected",
    selectAll: "Select all",
    selectNone: "Clear",
    noneSelected: "Pick at least one case.",
    version: "Version",
    noVersion: "No version",
    taskVersions: "This task's versions",
    otherVersions: "Other versions",
    build: "Build",
    buildPlaceholder: "e.g. 3.14.0",
    environment: "Environment",
    envPlaceholder: "e.g. staging",
    start: "Start round",
    started: "Round {{n}} started",
    finishTitle: "Finish round {{n}}",
    finishUntested: "{{count}} cases are still untested. Record one result for all of them:",
    finishUntestedAs: "Result for untested cases",
    finishNote: "Summary for the developer",
    finishOutcomeFail: "There are failures: the task goes back to the developer as “Changes requested”.",
    finishOutcomePass: "No failures: the task will be marked as passed.",
    finish: "Finish round",
    finished: "Round {{n}} finished",
    active: "In progress",
    done: "Finished",
    noRounds: "No rounds yet. A tester starts one when the task is ready for testing.",
    by: "Started by",
    when: "When",
    results: "Results",
    showMatrix: "Show results of round {{n}}",
    hideMatrix: "Hide results",
    actual: "Actual result",
    testedBy: "Tested by",
    addedLater: "added during the round",
    retestNoteLabel: "Developer's note",
  },
  cases: {
    key: "Key",
    case: "Case",
    priority: "Priority",
    tags: "Tags",
    reply: "Developer reply",
    filterStatus: "Result in current round",
    filterAll: "All",
    filterFailed: "Failed",
    filterStale: "Stale",
    filterUntested: "Untested",
    anyPriority: "Any priority",
    anyTag: "Any tag",
    showArchived: "Show archived",
    archived: "Archived",
    new: "NEW",
    editOrder: "Edit order",
    saveOrder: "Save order",
    moveUp: "Move {{key}} up",
    moveDown: "Move {{key}} down",
    orderSaved: "Order saved",
    noSection: "No section",
    noMatch: "No cases match these filters.",
    finding: "finding",
    notInRound: "Not in this round",
    roundColumn: "Round {{n}} result",
    open: "Open {{key}}",
  },
  caseDetail: {
    preconditions: "Preconditions",
    steps: "Steps",
    expected: "Expected",
    actual: "Actual · Round {{n}}",
    attachments: "Attachments",
    upload: "Attach files",
    dropHere: "Drop files here to attach them",
    uploading: "Uploading…",
    uploaded: "File attached",
    tooBig: "Files must be at most 100 MB.",
    noAttachments: "No attachments.",
    removeAttachment: "Remove {{name}}",
    attachmentRemoved: "Attachment removed",
    roundTag: "R{{n}}",
    history: "History",
    noHistory: "Not tested yet.",
    replies: "Developer replies",
    noReplies: "No replies yet.",
    replyKind: "Reply",
    replyNote: "Note",
    replyPlaceholder: "e.g. Added validation on the API; please retest.",
    sendReply: "Send reply",
    replied: "Reply sent",
    revisions: "Revisions",
    revN: "rev {{n}}",
    createdRev: "created",
    changed: "changed {{fields}}",
    noChanges: "no content changes",
    showDiff: "Show changes",
    hideDiff: "Hide changes",
    edit: "Edit",
    archive: "Archive",
    unarchive: "Restore",
    archivedToast: "Case archived",
    unarchivedToast: "Case restored",
    by: "{{name}} · {{time}}",
    fields: {
      title: "title",
      preconditions: "preconditions",
      steps: "steps",
      expected: "expected result",
      priority: "priority",
      tags: "tags",
      app: "app",
    },
    was: "was",
    now: "now",
    app: "App",
  },
  caseEditor: {
    stepsHint: "Enter adds the next step · pasting a list splits it into steps",
    newTitle: "New test case",
    editTitle: "Edit {{key}}",
    section: "Section",
    sectionHint: "Groups related cases, e.g. “Refunds”.",
    title: "What is checked",
    titlePlaceholder: "e.g. Refund above the paid amount is rejected",
    preconditions: "Preconditions",
    steps: "Steps",
    step: "Step {{n}}",
    addStep: "Add step",
    removeStep: "Remove step {{n}}",
    moveStepUp: "Move step {{n}} up",
    moveStepDown: "Move step {{n}} down",
    expected: "Expected result",
    priority: "Priority",
    tags: "Tags",
    tagsHint: "Comma-separated, e.g. negative, refunds",
    app: "App",
    noApp: "No app",
    saved: "Case saved",
    created: "Case {{key}} added",
    liveNotice: "A round is in progress — the tester will see this change flagged.",
  },
  runner: {
    back: "Back to task",
    progress: "{{done}} of {{total}} recorded · {{fail}} failed",
    shortcuts: "J / K move · P pass · F fail · B blocked · S skip · N note",
    skip: "Skip",
    note: "Note",
    noteRequired: "Describe what actually happened — required for fail and blocked.",
    notePlaceholder: "What actually happened?",
    paste: "Paste a screenshot (⌘V / Ctrl+V) or drop files",
    prev: "Previous",
    next: "Next",
    staleBanner: "This case changed after it was tested — please test it again.",
    archivedBanner: "This case was archived during the round.",
    addedLater: "Added during this round",
    previous: "Round {{n}}",
    devReply: "Developer · {{kind}}",
    readOnly: "You're viewing this round. Only testers and managers record results.",
    roundFinished: "This round is finished. Results are read-only.",
    addFinding: "Add finding",
    findingTitle: "New finding",
    findingHint: "A problem outside the written cases. It's added to this round as failed.",
    findingTitleLabel: "What's wrong",
    findingExpected: "Expected",
    findingActual: "Actual",
    findingAdded: "Finding {{key}} added",
    empty: "This round has no cases.",
    attachedTo: "Attached to {{key}}",
    cases: "Cases in this round",
    stepDone: "Step {{n}} done",
    clear: "Clear result",
    allDone: "Every case has a result. Finish the round when you're ready.",
  },
  activity: {
    empty: "No activity yet.",
    kinds: {
      task_created: "created the task",
      gitlab_link_added: "added a GitLab link",
      gitlab_link_confirmed: "confirmed a GitLab link",
      gitlab_link_removed: "removed a GitLab link",
      task_updated: "updated the task",
      task_transition: "changed the task state",
      cases_synced: "synced the test cases",
      case_created: "added a case",
      case_updated: "edited a case",
      case_archived: "archived a case",
      case_unarchived: "restored a case",
      cases_reordered: "reordered the cases",
      round_started: "started a round",
      round_finished: "finished a round",
      round_cases_added: "added cases to the round",
      result_recorded: "recorded a result",
      result_cleared: "cleared a result",
      finding_added: "added a finding",
      reply_added: "replied to a failure",
      attachment_added: "attached a file",
      attachment_deleted: "removed a file",
      task_title_changed: "renamed the task",
      task_description_changed: "edited the description",
      task_status_changed: "changed the status",
      task_due_changed: "changed the due date",
      task_priority_changed: "changed the priority",
      task_assignee_added: "assigned someone",
      task_assignee_removed: "unassigned someone",
      task_tester_changed: "changed the tester",
      task_parent_changed: "changed the parent task",
      task_epic_changed: "changed the epic",
      task_release_changed: "changed the release",
      task_tag_added: "added a tag",
      task_tag_removed: "removed a tag",
      task_attachment_added: "attached a file to the task",
      task_attachment_removed: "removed a file from the task",
      task_moved_out: "moved the task to another project",
      task_moved_in: "moved the task here",
      task_deleted: "deleted the task",
      task_mark_ready: "marked it ready for testing",
      task_request_retest: "requested a retest",
    },
    system: "Mixla",
    counts: {
      created: "{{count}} added",
      updated: "{{count}} changed",
      archived: "{{count}} archived",
    },
  },
  tokens: {
    apiDocs: "API docs →",
    tryIt: "Try it:",
    howToUse: "How to use this token →",
    revokeBotBody: "Anything using this token stops working immediately.",
    title: "CLI access",
    intro: "Personal tokens let the mixla CLI — and Claude through it — act as you. Treat them like passwords.",
    name: "Name",
    namePlaceholder: "e.g. MacBook · Claude Code",
    expiry: "Expires",
    days: "{{count}} days",
    create: "Create token",
    createdTitle: "Your new token",
    createdWarning: "Copy it now. It won't be shown again.",
    command: "Sign in the CLI with:",
    lastUsed: "Last used",
    created: "Created",
    expires: "Expires",
    revoke: "Revoke",
    revokeTitle: "Revoke “{{name}}”?",
    revokeBody: "The CLI using this token stops working immediately.",
    revoked: "Token revoked",
    empty: "No tokens yet.",
    done: "Done",
  },
  cliGuide: {
    title: "Set up the CLI + Claude Code",
    time: "about 5 minutes, once per computer",
    os: "Your system",
    install: {
      title: "Install the mixla CLI",
      body: "Works on macOS and Linux. It installs to ~/.local/bin and tells you if that isn't on your PATH yet. Run it again later to update.",
      bodyWindows: "Paste it into PowerShell. It installs mixla.exe for your user (no administrator rights) and adds it to your PATH. Run it again later to update.",
    },
    token: {
      title: "Create a personal token",
      body: "Use the form below. Name it after the computer, e.g. “MacBook · Claude Code”. The token is shown only once, together with the ready-made login command.",
      action: "Go to the token form",
    },
    login: {
      title: "Sign in the CLI",
      body: "Paste the login command from the token dialog (it already contains this server and your token). Then check who you are.",
    },
    skill: {
      title: "Teach Claude how to use Mixla",
      body: "Claude Code learns the Mixla workflow (pushing cases, fixing failures, bugs) from a short instruction file called a skill. Choose where to put it:",
      scope: "Where to install the skill",
      global: "All my repositories",
      globalTag: "recommended",
      globalHint: "Saved in your home folder (~/.claude/skills/mixla). Works in every repository on this computer; nothing to commit.",
      repo: "Only one repository",
      repoHint: "Saved inside that repository (.claude/skills/mixla). Commit it, and teammates who use Claude Code get it too.",
      repoCd: "cd path/to/your-repository",
      copy: "Copy skill",
      copyHint: "No CLI? Copy the skill and save it as",
    },
    link: {
      title: "Link a repository to its Mixla project (optional)",
      body: "Task commands already know the project from the task key (PAY-482 → PAY). For bug commands, write the project into the repository once, so neither you nor Claude has to pass --project:",
      project: "Project",
    },
    use: {
      todo: "What's waiting for me in Mixla?",
      title: "Ask Claude",
      body: "Open Claude Code in that repository and ask in plain words, for example:",
      push: "Push test cases for PAY-482",
      fix: "Fix the failures testers found on PAY-482",
      bug: "Look at BUG-12 and find the root cause",
    },
    trouble: "Not working? “mixla whoami” shows whether the CLI is signed in. A revoked or expired token needs a new token and login. The settings live in ~/.config/mixla/config.json.",
  },
};

export default tasksEn;

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
export type TasksTranslation = Shape<typeof tasksEn>;
